'use strict';

var FlightLegChartFilterFactory = function FlightLegChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightCabinFilterFactory', 'FlightDOWFilterFactory', 'FlightSeasonFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightLegChartFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-leg');
    this.registerFilters(injectedFilters);
  }
  FlightLegChartFilter.prototype = Object.create(DemandFilter.prototype);
  FlightLegChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightLegChartFilter;
};
FlightLegChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightLegChartFilterFactory;